import clx from 'classnames'
import LegendSquareIcon from './SquareIcon/SquareIcon'
import LegendLineIcon from './LineIcon/LineIcon'
import styles from './Legend.css'

const LAYOUT = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
}

const Legend = props => {
  // layout 是 rechart 的一個 property 用了會破壞設計的結構所以自己定一個 layoutType 傳入
  const { payload, align, layoutType, className } = props
  const isVertical = layoutType === LAYOUT.VERTICAL
  const Tag = isVertical ? 'p' : 'span'
  return (
    <div
      className={clx(styles.Legend, className)}
      style={{ textAlign: align }}
    >
      {payload.map((entry, index) => {
        const { type, value, color } = entry
        let Icon = null
        switch (type) {
          case 'square':
            Icon = LegendSquareIcon
            break
          case 'line':
            Icon = LegendLineIcon
            break
          default:
            break
        }
        return (
          <Tag
            key={`item-${index}`}
            className={clx(
              styles.tag,
              { [styles.vertical]: isVertical }
            )}
          >
            {Icon && <Icon color={color} />}
            {value}
          </Tag>
        )
      })}
    </div>
  )
}

export default Legend
